import { render } from "./HorizontalWithTitle.vue?vue&type=template&id=6ec30114&scoped=true"
import script from "./HorizontalWithTitle.vue?vue&type=script&lang=js"
export * from "./HorizontalWithTitle.vue?vue&type=script&lang=js"

import "./HorizontalWithTitle.vue?vue&type=style&index=0&id=6ec30114&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec30114"]])

export default __exports__